import { reactive } from 'vue'

const QUEUE_SCHLUESSEL = 'topfkucker_offline_queue'

export const Warteschlange = reactive([])

function QueueSpeichern() {
  try {
    localStorage.setItem(QUEUE_SCHLUESSEL, JSON.stringify([...Warteschlange]))
  } catch {} // eslint-disable-line no-empty
}

async function QueueAbarbeiten() {
  while (Warteschlange.length > 0) {
    const Eintrag = Warteschlange[0]
    try {
      const Antwort = await fetch(Eintrag.Url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(Eintrag.Koerper)
      })
      Warteschlange.splice(0, 1)
      QueueSpeichern()
      if (!Antwort.ok) {
        // Server-Fehler auf diesen Eintrag — überspringen, nicht endlos wiederholen
        console.warn(`Offline-Queue: ${Eintrag.Url} HTTP ${Antwort.status}, Eintrag übersprungen`)
      }
    } catch {
      break // Netzwerk noch nicht verfügbar — abbrechen
    }
  }
}

export function OfflineQueueInitialisieren() {
  try {
    const Gespeichert = localStorage.getItem(QUEUE_SCHLUESSEL)
    if (Gespeichert) Warteschlange.push(...JSON.parse(Gespeichert))
  } catch {} // eslint-disable-line no-empty

  window.addEventListener('online', QueueAbarbeiten)
  setInterval(QueueAbarbeiten, 30000)
}

function InQueueEinreihen(Url, Koerper) {
  Warteschlange.push({
    QueueId: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    Url,
    Koerper
  })
  QueueSpeichern()
}

// Für Update/Delete-Operationen:
// - Wendet die Änderung sofort lokal an (Optimistisch)
// - Bei Netzwerkfehler: Queue + lokale Änderung bleibt
// - Bei Server-Fehler: Rückgängig + Fehler wird propagiert
export async function Mutation(Url, Koerper, Optimistisch, Rueckgaengig) {
  if (Optimistisch) Optimistisch()
  let Antwort
  try {
    Antwort = await fetch(Url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(Koerper)
    })
  } catch {
    InQueueEinreihen(Url, Koerper)
    return undefined
  }
  if (!Antwort.ok) {
    if (Rueckgaengig) Rueckgaengig()
    const Daten = await Antwort.json().catch(() => ({}))
    throw new Error(Daten.Fehler || 'Unbekannter Fehler')
  }
  return Antwort.json().catch(() => ({}))
}

// Für Create-Operationen, die eine vom Server generierte ID benötigen:
// - Kein optimistisches Update (ID unbekannt)
// - Bei Netzwerkfehler: klare Fehlermeldung, kein Queue-Eintrag
export async function MutationMitRueckgabe(Url, Koerper) {
  let Antwort
  try {
    Antwort = await fetch(Url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(Koerper)
    })
  } catch {
    throw new Error('Kein Internetzugang. Bitte versuche es erneut, sobald du wieder online bist.')
  }
  if (!Antwort.ok) {
    const Daten = await Antwort.json().catch(() => ({}))
    throw new Error(Daten.Fehler || 'Unbekannter Fehler')
  }
  return Antwort.json()
}
